// extracted by mini-css-extract-plugin
module.exports = {"ImageOverlayComponent":"image-overlay_ImageOverlayComponent__Tv_OL","card":"image-overlay_card__4yjsX","closeButton":"image-overlay_closeButton__0HHPE"};